export default "__VITE_ASSET__CFwezfAj__"